import { useId, useState } from 'react';
import type { FunctionComponent } from 'react';
import { ChevronDown, ChevronRight, ChevronUp } from 'react-bootstrap-icons';
import { Transition } from '@headlessui/react';
import wcc_logo from '@assets/wcc_logo.svg';

const listItemStyles = `text-brand-primary hover:text-action-button-hover md:text-action-button md:hover:bg-action-button-hover flex w-full cursor-pointer items-center justify-between border-none bg-transparent py-5
px-2 font-[600] md:m-0 md:whitespace-nowrap md:rounded-[0.25rem] md:py-[5px] md:px-[10px] text-bodyLg md:text-body md:underline tracking-normal
md:hover:text-white md:hover:no-underline md:focus:bg-transparent md:active:bg-transparent md:active:text-white md:active:bg-action-button-hover md:active:outline-action-focus md:focus:text-black md:focus:bg-action-focus md:focus:outline-action-focus
`;

const ListItem: React.FC<{ href: string; label: string }> = ({
  href,
  label,
}) => (
  <li className=" border-b-brand-primary border-b-[1px] border-solid border-opacity-25 last:border-b-transparent md:border-b-transparent">
    <a href={href} className={listItemStyles} target="_blank" rel="noreferrer">
      {label}
      <ChevronRight className="text-2xl md:hidden" />
    </a>
  </li>
);

export const menuItems = [
  {
    href: 'https://www.westminster.gov.uk/residents',
    label: 'Residents',
  },
  {
    href: 'https://www.westminster.gov.uk/businesses',
    label: 'Businesses',
  },
  {
    href: 'https://www.westminster.gov.uk/portals',
    label: 'MyWestminster accounts',
  },
];

const List = () => (
  <ul className="md:flex md:gap-x-[10px]">
    {menuItems.map((item) => (
      <ListItem key={item.href} {...item} />
    ))}
  </ul>
);

export const WCCHeader: FunctionComponent = () => {
  const [open, setOpen] = useState(false);
  const id = useId();

  const toggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  return (
    <header>
      <nav
        aria-label="Primary"
        className="bg-background-paper border-b-solid border-b-accent-highlight min-h-[5rem] w-[100vw] items-stretch border-b-[4px] px-[0.5rem] py-4 sm:items-center md:px-3"
      >
        <div className="mx-auto flex w-full  items-center justify-between pt-1 lg:container">
          <a
            href="https://www.westminster.gov.uk"
            className="outline-link-focus-bg focus:bg-link-focus-bg"
            target="_blank"
            rel="noreferrer"
          >
            <img
              src={wcc_logo}
              className={`h-[2rem] w-[8.25rem]`}
              alt="Westminster Gov HomePage"
            />
          </a>
          <button
            className="secondary-button border-action-button text-action-button hover:bg-action-button active:shadow-action-focus focus:bg-action-focus
             active:bg-action-button hover:bg-action-button flex items-center gap-2 rounded border-2
             p-2 text-xl font-medium hover:text-white focus:border-[0.125rem] focus:border-solid focus:border-transparent
             focus:text-black focus:outline-none active:text-white active:shadow-[0_0_0_0.25rem] md:hidden"
            onClick={toggle}
            aria-controls={id}
            aria-expanded={open}
          >
            Menu
            {open ? (
              <ChevronUp className="icon-chevron text-sm" />
            ) : (
              <ChevronDown className="icon-chevron text-sm" />
            )}
          </button>

          <div className="hidden md:flex md:justify-end	">
            <div id={id}>
              <List />
            </div>
          </div>
        </div>
        <div className="md:hidden">
          <Transition
            show={open}
            as="div"
            className="grid overflow-hidden"
            enter="transition-[grid-template-rows] motion-reduce:transition-none duration-150"
            enterFrom="grid-rows-[0fr]"
            enterTo="grid-rows-[1fr]"
            leave="transition-all motion-reduce:transition-none duration-150"
            leaveFrom="grid-rows-[1fr]"
            leaveTo="grid-rows-[0fr]"
          >
            <div id={id} className="min-h-0">
              <List />
            </div>
          </Transition>
        </div>
      </nav>
    </header>
  );
};
